import React from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import classNames from 'classnames'

const Breadcrumbs = ({ list, prefix, target = '_self' }) => {
  return (
    <ol className='flex list-reset gap-half mb3'>
      {list?.map((crumb, i) => {
        const { link, caption } = crumb

        let isLatestParent = false
        if (list.length - 1 > 0) {
          isLatestParent = list.length - 2 === i
        }

        return (
          <li
            key={`crumb-${crumb.caption}`}
            className={classNames('mxd-lister-breadcrumbs--lg-only', {
              'mxd-lister-breadcrumbs--always-visible': isLatestParent
            })}
          >
            <a
              href={link}
              className='flex items-center gap-half link-radius'
              target={target}
              {...(i === list.length - 1 && { 'aria-current': 'page' })}
              {...(isLatestParent && { 'aria-label': `${prefix} ${caption}` })}
            >
              <FaChevronLeft className='mxd-lister-breadcrumbs--sm-only' fontSize='0.7em' />
              <span className='flex'>
                {prefix && <span className='mxd-lister-breadcrumbs--sm-only'>{prefix}&nbsp;</span>}
                {caption}
              </span>
              {i < list.length - 1 && <FaChevronRight className='mxd-lister-breadcrumbs--lg-only' fontSize='0.7em' />}
            </a>
          </li>
        )
      })}
    </ol>
  )
}

export default Breadcrumbs
